import { t } from "../locale";

/**
 * @param {FarmcamSim} fcs
 * @returns {string}
 */
function checkRemainingData(fcs) {
	if (Date.now() > new Date(fcs.Subscription.ExpiresAt).getTime()) return "";

	if (fcs.RemainingData < 1) {
		return t.farmcamSim.card.outOfDataWarning;
	}

	if (fcs.RemainingData < 20e6) {
		return t.farmcamSim.card.lowDataWarning;
	}

	return "";
}

/**
 * @param {FarmcamSim} fcs
 * @returns {string[]}
 */
function getFarmcamSimWarnings(fcs) {
	return [checkRemainingData(fcs)].filter((text) => text !== "");
}

export { getFarmcamSimWarnings };
